export type InsertOrUpdateOptions = {
    skipUpdateIfNoValuesChanged?: boolean;
};